import { useTranslation } from 'react-i18next';

import { Icons } from '@/shared/ui';

import styles from './ViewOptions.module.css';
import type { CalendarPrefs } from './prefs';

/**
 * Two compact display switches of the calendar: hide past events (an eye) and the daily workload
 * (bars). Icon buttons with a pressed state, so they cost no toolbar row on a phone.
 */
export function ViewOptions({
  prefs,
  onChange,
}: {
  prefs: CalendarPrefs;
  onChange: (patch: Partial<CalendarPrefs>) => void;
}) {
  const { t } = useTranslation();
  return (
    <div className={styles.options} role="group" aria-label={t('calendar.viewOptions')}>
      <button
        type="button"
        className={styles.button}
        aria-pressed={prefs.hidePast}
        aria-label={t('calendar.hidePast')}
        title={`${t('calendar.hidePast')}. ${t('calendar.hidePastHint')}`}
        data-testid="hide-past"
        onClick={() => {
          onChange({ hidePast: !prefs.hidePast });
        }}
      >
        {prefs.hidePast ? <Icons.eyeOff /> : <Icons.eye />}
      </button>
      <button
        type="button"
        className={styles.button}
        aria-pressed={prefs.workload}
        aria-label={t('calendar.workload.toggle')}
        title={`${t('calendar.workload.toggle')}. ${t('calendar.workload.hint')}`}
        data-testid="show-workload"
        onClick={() => {
          onChange({ workload: !prefs.workload });
        }}
      >
        <Icons.workload />
      </button>
    </div>
  );
}
